import { inject, Injectable, signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { IdleWarningTimerComponent } from '@shared/components/idle-warning-timer/idle-warning-timer.component';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { merge } from 'rxjs/internal/observable/merge';
import { timer } from 'rxjs/internal/observable/timer';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime, mergeMap, switchMap, takeUntil, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  private dialog = inject(MatDialog);


  private idleTimeLimit = 5 * 60 * 1000; // 5 min
  private warningTime = environment.idle_timeout * 1000;
  private stopIdleTimer$!: Subject<void>;
  private stopWarningTimer$!: Subject<void>;

  logoutTime: number;
  dialogRef: MatDialogRef<IdleWarningTimerComponent>;

  isSessionLogout = signal(false);

  isAlreadySessionExists = false;

  constructor() { }

  set setLogoutTime(logoutTime: number) {
    this.logoutTime = logoutTime;
  }

  startWatching(ms: number) {
    this.isAlreadySessionExists = true;

    this.stopIdleTimer$ = new Subject<void>();
  
    const userEvents$ = merge(
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'keypress'),
      fromEvent(window, 'click'),
      fromEvent(window, 'scroll')
    );
  
    userEvents$.pipe(
      debounceTime(300),
      switchMap(() => this.createIdleTimer(ms)),
      takeUntil(this.stopIdleTimer$)
    ).subscribe();
  }

  createIdleTimer(ms: number) {
    // console.log(`Session timeout set for ${ms} millisecs`);
    return timer(ms).pipe(
      tap(() => {
        this.showWarning();

        this.startWarningTimer();

        this.stopWatching();
      })
    );
  }
  
  startWarningTimer() {
    this.stopWarningTimer$ = new Subject<void>();

    timer(this.warningTime).pipe(
      takeUntil(this.stopWarningTimer$)
    ).subscribe(() => {
      this.logout();
    });
  }

  showWarning() {
    // alert('session will expire');

    this.dialogRef = this.dialog.open(IdleWarningTimerComponent, {
      disableClose: true,
      panelClass:'dialog-padding',
      // width:'30%',
      width: '42%',
      // height:'35%',
    });
  }

  stopWatching() {
    this.isAlreadySessionExists = false;

    this.stopIdleTimer$.next();
    this.stopIdleTimer$.complete();
  }
  stopWarningTimer() {
    this.stopWarningTimer$.next();
    this.stopWarningTimer$.complete();
  }

  logout() {
    this.dialogRef?.close();
    this.isSessionLogout.set(true);
  }
}
